module.exports = __webpack_public_path__ + "media/images/page_placeholder-2c9213043ed42f0350d5eca68f9f74f1.png";